import ExportsPaginationTable from './ExportsPaginationTable';

export default ExportsPaginationTable;
